// extracted by mini-css-extract-plugin
export default {"cell":"MapCell_cell__o-KDX","editable":"MapCell_editable__LwZWS"};